import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import background from "../assets/intervention.png";
import RatingGameContainer from "./RatingGameContainer";
import MultipleChoiceIntervention from "./MultipleChoiceIntervention";
import GameResult from "./GameResultIntervention";
import useAuth from "../../auth/hooks/useAuth";
import axios from "axios";
import { ImageBackground, Text, View, StyleSheet } from 'react';
import abydos_game_bg from "../assets/intervention.png";
import { Scale } from 'react-scaling';

var subjectNum = 0;
var levelNum = 0;

export default function InterventionGame({ ...props }) {
  const [correctInRow, setCorrectInRow] = useState(0);
  const [game, setGame] = useState(props.game);
  const { state: authState } = useAuth();
  //const [levelNum, setLevel] = useState(0);
  const [lives, setLives] = useState(4);
  const [score, setScore] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [questions, setQuestions] = useState(props.questionslist);
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [correctForLevel, setCorrectForLevel] = useState(0);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [incorrectAnswers, setIncorrectAnswers] = useState(0);
  const [toggle, setToggle] = useState(false);
  const [maxDifficultyLevel, setMaxDifficultyLevel] = useState(
    questions.length - 1
  );
  const [maxTime, setMaxTime] = useState(
    props.defaultTimer ? props.defaultTimer : 330
  );
  const [remainingTime, setRemainingTime] = useState(
    props.defaultTimer ? props.defaultTimer : 330
  );
  const [gameover, setGameover] = useState(false);
  const [timeOnComplete, setTimeOnComplete] = useState(0);

  //used for submissions
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  //const [subjectNum, setQuestionNumber] = useState(0);

  const submitRating = useCallback(async () => {
    const parameters = {
      rating: score,
      service_key: game.service_key
    };

    try {
      if (gameover === true) {
        const response = await axios({
          url: `${process.env.REACT_APP_API}/ratings`,
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${authState.access_token}`
          },
          data: parameters
        });
      }
    } catch (e) {
      // throw new Error(e);
    }
  }, [gameover, score]);

  useEffect(() => {
    if (remainingTime > 0) {
      var timerID = setInterval(() => decrementTimer(), 1000);
      return () => {
        clearInterval(timerID);
      };
    }
  }, [remainingTime]);

  function decrementTimer() {
    setRemainingTime(remainingTime - 1);
  }

  //SUBMIT METHOD
  function submit(answer, question) {
    console.log(answer);
    console.log(question);
    var dupeQuestion = {
      answer: answer,
      topic_id: question.topic_key,
      num_asked: 1,
      num_correct: 0,
    };

    if (answer.correct === true) {
      setCorrectInRow(correctInRow + 1);
      setCorrectForLevel(correctForLevel + 1);
      setCorrectAnswers(correctAnswers + 1);
      dupeQuestion.num_correct = 1;
      setCorrectQuestions([...correctQuestions, dupeQuestion]);

      if ((correctInRow == 5 && levelNum == 0) || (correctInRow == 6 && levelNum == 1) || (correctInRow == 7 && levelNum > 1) || correctForLevel === 9) {
        levelNum++;
        setLives(4);
        setCorrectInRow(0);
        subjectNum = 0;
        console.log(levelNum);
        console.log(subjectNum)
        console.log(questions[levelNum]);
        if (questions[levelNum] != undefined) {
          setCurrentQuestion(
            questions[levelNum][0][Math.floor(Math.random() * questions[levelNum][subjectNum].length)]
          );
        }
      } else {
        if (questions[levelNum] !== undefined) {
          console.log("here?")
          console.log(questions)
          console.log(questions[levelNum].length);
          if (subjectNum >= questions[levelNum].length - 1) {
            console.log("number is above length")
            subjectNum = 0;
          } else {
            subjectNum++;
          }
          console.log(subjectNum)
          console.log(currentQuestion)
          setCurrentQuestion(
            questions[levelNum][subjectNum][Math.floor(Math.random() * questions[levelNum][subjectNum].length)]
          );
        }
      }
    } else {
      dupeQuestion.num_correct = 0;
      setIncorrectQuestions([...incorrectQuestions, dupeQuestion]);
      setIncorrectAnswers(incorrectAnswers + 1);
      setCorrectInRow(0);
      setLives(lives - 1);

      let correctAnswer = question.answers.filter(answer => {
        return answer.correct === true;
      });

      let result = {
        question: question.question.replace("$", "_"),
        correct: correctAnswer[0].value,
        incorrect: answer.value
      };
      subjectNum++;
      if (levelNum > questions.length - 1)
        levelNum = 0;
      if (subjectNum > questions[levelNum].length - 1) {
        console.log("bigger");
        subjectNum = 0;
      }

      setFeedback([...feedback, result]);
      console.log(questions);
      console.log(questions[levelNum]);
      console.log(subjectNum);
      console.log(questions[levelNum][subjectNum])
      setCurrentQuestion(
        questions[levelNum][subjectNum][Math.floor(Math.random() * questions[levelNum][subjectNum].length)]
      );
    }
    console.log(levelNum);
    console.log(subjectNum);
    //console.log(randQuestion);
    console.log(questions);
  }

  // set the first question
  useEffect(() => {
    if (questions !== undefined) {
      console.log(props);
      console.log(questions);
      console.log(questions[0][0])
      setCurrentQuestion(questions[0][0][0]);
      subjectNum = 0;
      levelNum = 0;
    }
  }, []);

  useEffect(() => {
    if (levelNum !== 0) {
      //award 150 pts for each levelNum increase
      setScore(score + 150);
    }
    // if completed the game
    if (levelNum > maxDifficultyLevel) {
      setTimeOnComplete(remainingTime);
      let totalAnswers = correctAnswers + incorrectAnswers;
      let numAnswersScore = (110 - totalAnswers) * 3;

      // add 150 for the final score increase
      let finalScore = numAnswersScore + timeOnComplete + 150;
      setScore(score + finalScore);
      setGameover(true);
      SubmitTopics();
    } else {
      setCorrectForLevel(0);
      if (questions !== undefined && questions[levelNum] !== undefined) {
        console.log(questions);
        for (let i = 0; i < 100; i++) {
          let num = Math.round(0 + Math.random() * questions[levelNum][subjectNum].length - 1);
        }
        setCurrentQuestion(
          questions[levelNum][subjectNum][Math.floor(Math.random() * questions[levelNum][subjectNum].length)]//TODO FIX THIS
        );
      }
    }
  }, [levelNum]);

  useEffect(() => {
    if (
      currentQuestion !== undefined &&
      currentQuestion.answers !== undefined
    ) {
      const correctAnswer = currentQuestion.answers.filter(answer => {
        return answer.correct === true;
      });
    }
  }, [currentQuestion]);

  useEffect(() => {
    if (gameover == true) {
      //submitRating();
    }
  }, [gameover]);

  useEffect(() => {
    if (lives === 0) {
      //failed the game
      setTimeOnComplete(remainingTime);
      let failedScore = correctForLevel / 9;
      let finalScore = failedScore * 150;
      setScore(score + finalScore);
      setGameover(true);
      SubmitTopics();
      //submitRating();
    }
  }, [lives]);

  function restartGame() {
    setCorrectInRow(0);
    levelNum = 0;
    subjectNum = 0;
    setLives(4);
    setScore(0);
    setFeedback([]);
    setCorrectForLevel(0);
    setIncorrectAnswers(0);
    setCorrectAnswers(0);
    setRemainingTime(maxTime);
    setGameover(false);
    setTimeOnComplete(0);
  }

  function SubmitTopics() {
    if (submitted == true) {
      return
    }
    setSubmitted(true);
    console.log(correctQuestions);
    console.log(incorrectQuestions);

    let average_ans_time = parseFloat((props.defaultTimer ? props.defaultTimer : 30) / (correctQuestions.length + incorrectQuestions.length)).toFixed(2);

    let correctByTopics = correctQuestions.reduce((byTopics, question) => {
      byTopics[question.topic_id] = byTopics[question.topic_id] || [];
      byTopics[question.topic_id].push(question);
      return byTopics;
    }, {});
    let incorrectByTopics = incorrectQuestions.reduce((byTopics, question) => {
      byTopics[question.topic_id] = byTopics[question.topic_id] || [];
      byTopics[question.topic_id].push(question);
      return byTopics;
    }, {});

    window.correctByTopics = correctByTopics;
    window.incorrectByTopics = incorrectByTopics;
    console.log(correctByTopics);
    console.log(incorrectByTopics);

    let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
      let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
      let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
      console.log("topicID");
      console.log(topic_id);
      let tempTopicID = (topic_id);
      let tempAverageAnswerTime = parseFloat(average_ans_time);
      return {
        //topic_id: tempTopicID,
        topic_key: topic_id,
        num_correct,
        num_asked: num_correct + num_incorrect,
        average_ans_time: tempAverageAnswerTime
      }
    });
    console.log(topicstats);

    axios({
      url: `${process.env.REACT_APP_API}/submissions`,
      method: "post",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authState.access_token}`
      },
      data: {
        "homework_id": props.homework_id,
        "topicstats": topicstats,
        "level_reached": levelNum
      }
    });
  }

  return (
    <RatingGameContainer

      correctInRow={correctInRow}
      level={levelNum}
      lives={lives}
      onBack={() => props.onBack()}
      restart={() => {
        setCorrectInRow(0);
        levelNum = 0;
        subjectNum = 0;
        setLives(4);
      }}
    >

      {!gameover ? (
        //style={{justifyContent: 'center', alignItems: 'center'}}
        <div style={{ backgroundImage: `url(${abydos_game_bg})`, backgroundSize: "cover", height: "100%" }} >
          <Scale scaleTo={1720}>
            <div>
              <Body>
                {currentQuestion !== undefined && (
                  <MultipleChoiceIntervention

                    currentQuestion={currentQuestion}
                    onSubmit={submit}
                    playAudio={props.playAudio}
                  />
                )}
                {(currentQuestion.questionLine2 === undefined) ? "" :
                  <Question
                    type="text"
                    disabled
                    value={
                      currentQuestion.questionLine2
                    }
                  />
                }


              </Body>
            </div>
          </Scale>
        </div>

      )
        : (
          <GameResult
            level={levelNum}
            feedback={feedback}
            score={Math.round(score)}
            correct={correctAnswers}
            incorrect={incorrectAnswers}
            questionFontSize="0.7em"
            onRestartGame={() => restartGame()}
            onBack={() => props.onBack()}
            speed={parseFloat(
              (maxTime - timeOnComplete) / (incorrectAnswers + correctAnswers)
            ).toFixed(2)}
          />
        )}
    </RatingGameContainer>
  );

}

const Body = styled.div`
            width: 100%;
            height: 100%;
            background-image: url();
            background-size: cover;
            background-position: 0px -1px;
            display: flex;
            justify-content: center;
            padding-top: 100px;
          `;

const Question = styled.input`
            width: 70%;
            height: 120px;
            line-height: 90px;
            user-select: none;
            font-size: 2.3vw;
            margin: 15px 25px;
            text-align: center;
            font-weight: 600;
            border: none;
            border-radius: 10px;
            flex: 1
            top: 350px
            position: fixed
          `;
